import { useState } from "react";

import Lightbox from "../../common/Lightbox";
import { IProject } from "../../../data_models/project";
import useProjects from "../../../hooks/useProjects";
import useDisplayNotifications from "../../../hooks/useDisplayNotifications";


interface VerificationPmAgreeToContinueProps {
    projectId: string;
    onClose: () => void;
    onUpdateProject: (project: IProject) => void;
}

const VerificationPmAgreeToContinue: React.FC<VerificationPmAgreeToContinueProps> = ({ projectId, onClose, onUpdateProject }) => {


    const [loadingConfirm, setLoadingConfirm] = useState(false);
    const [loadingCancel, setLoadingCancel] = useState(false);
    const { roadmapVerificationPmAgreeToContinue } = useProjects();
    const { addErrorNotification, addSuccessNotification } = useDisplayNotifications();


    const onAgreeToContinue = async () => {
        try {
            setLoadingConfirm(true);
            const result = await roadmapVerificationPmAgreeToContinue(projectId, true);
            onUpdateProject(result);
            addSuccessNotification("In case, the client agrees, you'll be assigned as project manager to this project in the next steps.");
        } catch (error: any) {
            addErrorNotification(error.message);
        } finally {
            setLoadingConfirm(false);
            onClose();
        }
    }

    const onNotAgreeToContinue = async () => {
        try {
            setLoadingCancel(true);
            const result = await roadmapVerificationPmAgreeToContinue(projectId, false);
            onUpdateProject(result);
            addSuccessNotification("You'll not continue working on this project.");
        } catch (error: any) {
            addErrorNotification(error.message);
        } finally {
            setLoadingCancel(false);
            onClose();
        }
    }

    return (
        <Lightbox
            header="Continue as Project Manager?"
            content={
                <div className="flex flex-col items-start space-y-3" >
                    <p>Are you happy to take the lead as project manager and guide this project to success?
                        If the client agrees, you’ll earn extra credits for each task completed!</p>
                </div>}
            confirmText="Yes, I'll take the lead"
            onConfirm={onAgreeToContinue}
            cancelText="No, I'll not continue working on this project"
            onCancel={onNotAgreeToContinue}
            loadingConfirm={loadingConfirm}
            loadingCancel={loadingCancel}
            onClose={onClose}
        />

    );
}

export default VerificationPmAgreeToContinue;
